export default "__VITE_ASSET__nO6R1nbd__"